import { Transition } from '@headlessui/react';
import { SizeMe } from 'react-sizeme';
import type { ReactNode } from 'react';
import clsx from 'clsx';

const defaultSticky =
    'bottom-0 px-8 xl:px-20 border-icoGray-300 dark:border-icoDarkMode-beton border-t border-solid fixed w-full z-10' as const;

const stickyVariant = {
    sm: 'py-3 bg-white dark:bg-icoDarkMode-anthracite justify-end',
    lg: 'py-5 bg-white/80 backdrop-blur-lg firefox:bg-gradient-to-tr firefox:from-icoGrayFirefox-300 firefox:to-icoWhiteFirefox dark:bg-icoDarkMode-anthracite/30 justify-center',
    downgrade: 'py-8 bg-icoGray-100 dark:bg-icoDarkMode-deepBlack justify-center'
} as const;

type StickySaveProps = {
    children: ReactNode;
    className?: string;
    isVisible: boolean;
    variant?: keyof typeof stickyVariant;
    availableOnMobile?: boolean;
};
const StickySave = ({
    children,
    className,
    isVisible,
    variant = 'sm',
    availableOnMobile = false
}: StickySaveProps) => {
    return (
        <SizeMe>
            {({ size }) => (
                <div className="w-full">
                    <Transition
                        show={isVisible}
                        enter="transition ease-in-out duration-500 transform"
                        enterFrom="translate-y-full"
                        enterTo="translate-y-0"
                        leave="transition ease-in-out duration-300 transform"
                        leaveFrom="translate-y-0"
                        leaveTo="translate-y-full"
                        style={{
                            width: `${size.width}px`
                        }}
                        className={clsx(
                            defaultSticky,
                            {
                                'hidden lg:flex': !availableOnMobile,
                                flex: availableOnMobile
                            },
                            stickyVariant[variant],
                            className
                        )}>
                        {children}
                    </Transition>
                </div>
            )}
        </SizeMe>
    );
};

export default StickySave;
